module.exports = __webpack_public_path__ + "static/media/hourglass_1.d4cb52a2.svg";